import { theaterPause, theaterPlay } from './modules/activate';
import * as Container from './modules/container';
import { content, theaterInit } from './modules/content';
import { breakpoint, classNames, selectors } from './modules/lib';
import { mobileScrollObserver } from './modules/mobile';

const observer = new IntersectionObserver((entries) => {
	entries.forEach((entry) => {
		const ctr = entry.target;
		const theater = content[ctr.id].objs.filter((t) => t.active === true)[0];
		if (entry.isIntersecting) {
			if (Container.hasLoaded(ctr) && Container.isPaused(ctr)) {
				theaterPlay(theater, ctr.id);
			}
		} else if (Container.hasLoaded(ctr)) {
			theaterPause(theater, ctr.id);
		}
	});
});

const containers = document.querySelectorAll(selectors.primaryCtr);

containers.forEach((ctr) => {
	const isMobile = ctr.classList.contains(classNames.mobile);

	theaterInit(ctr);

	// Decide whether mobile processing should be done.
	if (isMobile) {
		mobileScrollObserver(ctr);
	} else if (!ctr.classList.contains(classNames.bottomNav)) {
		window.addEventListener('resize', () => {
			const windowWidth = document.querySelector('html').clientWidth;

			windowWidth < breakpoint ? ctr.classList.add(classNames.bottomNav) : ctr.classList.remove(classNames.bottomNav);
		});
	}

	observer.observe(ctr);
});
